
    // Hide the loader once the page is loaded
    window.addEventListener("load", function() {
      const loader = document.getElementById("loader");
      if (loader) {
        loader.style.display = "none";
      }
    });
  